import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import API_ENDPOINTS from '../../utils/api';

export const fetchOrderBilling = createAsyncThunk(
  'orders/fetchOrderBilling',
  async ({ slug, data }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        API_ENDPOINTS.ORDER_BILLING(slug),
        data
      );

      if (!response || !response.data) {
        throw new Error('No response data received from the API');
      }

      return response.data;
    } catch (error) {
      console.error('🚨 Billing API Error:', error.response?.data || error);
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          'Failed to fetch order billing'
      );
    }
  }
);

// Place Order API
// export const placeOrder = createAsyncThunk(
//   'orders/placeOrder',
//   async ({ slug, orderData }, { rejectWithValue }) => {
//     try {
//       const response = await axios.post(
//         API_ENDPOINTS.ORDER_PLACE(slug),
//         orderData
//       );

//       if (!response || !response.data) {
//         throw new Error('No response data received from the API');
//       }

//       return response.data;
//     } catch (error) {
//       console.error('🚨 Order API Error:', error.response?.data || error);
//       return rejectWithValue(
//         error.response?.data?.message ||
//           error.message ||
//           'Failed to place order'
//       );
//     }
//   }
// );
export const placeOrder = createAsyncThunk(
  'orders/placeOrder',
  async ({ slug, formData }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        API_ENDPOINTS.ORDER_PLACE(slug),
        formData,
        {
          headers: {
            'Content-Type': 'multipart/form-data',
          },
        }
      );

      if (!response || !response.data) {
        throw new Error('No response data received from the API');
      }

      return response.data;
    } catch (error) {
      console.error('🚨 Order API Error:', error.response?.data || error);
      return rejectWithValue(
        error.response?.data?.message ||
          error.message ||
          'Failed to place order'
      );
    }
  }
);

const orderSlice = createSlice({
  name: 'orders',
  initialState: {
    order: null,
    billingData: null,
    loading: false,
    billingError: null,
    orderError: null,
  },
  reducers: {
    saveOrder: (state, action) => {
      state.order = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchOrderBilling.pending, (state) => {
        state.loading = true;
        state.billingError = null;
      })
      .addCase(fetchOrderBilling.fulfilled, (state, action) => {
        state.loading = false;
        state.billingData = action.payload;
      })
      .addCase(fetchOrderBilling.rejected, (state, action) => {
        state.loading = false;
        state.billingError = action.payload || 'Failed to fetch order billing';
      })
      .addCase(placeOrder.pending, (state) => {
        state.loading = true;
        state.orderError = null;
      })
      // .addCase(placeOrder.fulfilled, (state, action) => {
      //   state.loading = false;
      //   state.order = action.payload;
      // })
      .addCase(placeOrder.rejected, (state, action) => {
        state.loading = false;
        state.orderError = action.payload || 'Failed to place order';
      });
  },
});

export const { saveOrder } = orderSlice.actions;
export default orderSlice.reducer;
